import { c as _c } from "react/compiler-runtime";
import { DropdownAction, DropdownActionMenuItem } from 'platform/components';
import { RowActionItem } from '../../../../../../../../utils/partitionRowActions';
type ActionButtonSize = 'small' | 'default';
export type RowActionsOverflowProps = {
  overflowActions: RowActionItem[];
  onActionClick: (actionKey: string, nativeEvent: MouseEvent) => void;
  rowId: string;
  buttonSize: ActionButtonSize;
  isDisabled: boolean;
  lockedActionKeys: Set<string>;
};

/**
 * Overflow dropdown trigger for row actions without icons.
 * Renders a three-dot IconButton (more_vert) that opens a dropdown menu
 * with text-only action items.
 *
 * Returns null when overflowActions is empty — no trigger rendered.
 */
export function RowActionsOverflow(props) {
  const $ = _c(7);
  if (props.overflowActions.length === 0) {
    return null;
  }
  let t0;
  if ($[0] !== props) {
    t0 = props.overflowActions.map(action => ({
      label: action.definition.title,
      isDisabled: props.isDisabled || props.lockedActionKeys.has(action.actionKey),
      onClick: event => props.onActionClick(action.actionKey, event.nativeEvent as MouseEvent),
      "data-testid": `menuItem-rowAction.${action.actionKey}`
    }));
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const menuItems = t0;
  const t1 = `button-rowAction.overflow-${props.rowId}`;
  let t2;
  if ($[2] !== menuItems || $[3] !== props.buttonSize || $[4] !== props.isDisabled || $[5] !== t1) {
    t2 = <DropdownAction type="dropdown-iconButton" size={props.buttonSize} menuItems={menuItems} isDisabled={props.isDisabled} data-testid={t1} />;
    $[2] = menuItems;
    $[3] = props.buttonSize;
    $[4] = props.isDisabled;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}